import Pluralize from 'pluralize';
import store from '@app/store';
import { RouteServiceInterface } from '@core/interfaces/route-service-interface';
import { ApiRouteConfig } from '@core/interfaces/core-services';

export default class BPCApiRouteService implements RouteServiceInterface {
  private _apiScheme: string;
  private _apiDomain: string;
  private _apiPath: string;
  private _imagePath: string;

  constructor(apiRouteConfig: Partial<ApiRouteConfig> = {}) {
    const defaultApiRouteConfig: ApiRouteConfig = {
      apiScheme: process.env.VUE_APP_API_SCHEME,
      apiDomain: process.env.VUE_APP_API_DOMAIN,
      apiPath: process.env.VUE_APP_API_PATH,
      imagePath: process.env.VUE_APP_IMAGEPATH,
    };

    const mergedConfig: ApiRouteConfig = {
      ...defaultApiRouteConfig,
      ...apiRouteConfig,
    };

    this._apiScheme = mergedConfig.apiScheme;
    this._apiDomain = mergedConfig.apiDomain;
    this._apiPath = mergedConfig.apiPath;
    this._imagePath = mergedConfig.imagePath;
  }

  apiScheme(): string {
    return this._apiScheme;
  }
  apiDomain(): string {
    return this._apiDomain;
  }
  apiPath(): string {
    return this._apiPath;
  }
  imagePath(): string {
    return this._imagePath;
  }

  getBaseUrl(): string {
    return `${this.apiScheme()}://${this.apiDomain()}`;
  }

  getApiBaseUrl(): string {
    const apiPath = this.addInitialSlash(this.apiPath());
    return `${this.getBaseUrl()}${apiPath}`;
  }

  getApiUrl(entityPath: string): string {
    const apiBaseUrl = this.getApiBaseUrl().replace(/\/$/, '');
    const path = this.addInitialSlash(entityPath);
    return `${apiBaseUrl}${path}`;
  }

  getRawUrl(path: string): string {
    const apiBaseUrl = this.getApiBaseUrl().replace(/\/$/, '');
    const pathSlashed = this.addInitialSlash(path);
    return `${apiBaseUrl}${pathSlashed}`;
  }

  getPlural(str: string): string {
    return Pluralize.isSingular(str) ? Pluralize(str) : str;
  }

  getSingular(str: string): string {
    return Pluralize.isPlural(str) ? Pluralize.singular(str) : str;
  }

  addInitialSlash(str: string): string {
    return str.startsWith('/') ? str : `/${str}`;
  }

  removeFinalSlash(str: string): string {
    return str.replace(/\/$/, '');
  }

  getTenantId() {
    return store.getters['tenant/selectedTenantId'];
  }
}
